
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "ErrorMessageWrapper3499888865",
      {"classes":{"root":"ErrorMessageWrapper3499888865__root","message":"ErrorMessageWrapper3499888865__message","icon":"ErrorMessageWrapper3499888865__icon","messageWithSuffix":"ErrorMessageWrapper3499888865__messageWithSuffix"},"vars":{"wut-error-color":"--wut-error-color"},"stVars":{"DefaultErrorColor":"#DF3131","DefaultMinMessageHeight":"0","ErrorColor":"--overridable","MinMessageHeight":"--overridable","errorColor":"\"color(fallback(--overridable, #DF3131))\"","fixedMinHeight":"20px","fixedMarginTop":"8px"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  